module.exports = __webpack_public_path__ + "static/img/image4.d4f4731a.png";